import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scroll the window to the top whenever the route pathname changes.
// This guarantees product pages (and every other page) always open at the top.
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    // Use auto to avoid smooth-scroll animation on page changes
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);
  return null;
};

export default ScrollToTop;
